import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WindowIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.28 11.02C13.54 11.02 12.94 10.42 12.94 9.66V5.9C12.94 5.16 13.54 4.56 14.28 4.56H18.04C18.8 4.56 19.4 5.16 19.4 5.9V9.66C19.4 10.42 18.8 11.02 18.04 11.02H14.28ZM5.94 11.02C5.2 11.02 4.6 10.42 4.6 9.66V5.9C4.6 5.16 5.2 4.56 5.94 4.56H9.7C10.46 4.56 11.06 5.16 11.06 5.9V9.66C11.06 10.42 10.46 11.02 9.7 11.02H5.94ZM6.1 9.52H9.56V6.06H6.1V9.52ZM14.44 9.52H17.9V6.06H14.44V9.52ZM14.28 19.36C13.54 19.36 12.94 18.76 12.94 18V14.24C12.94 13.5 13.54 12.9 14.28 12.9H18.04C18.8 12.9 19.4 13.5 19.4 14.24V18C19.4 18.76 18.8 19.36 18.04 19.36H14.28ZM5.94 19.36C5.2 19.36 4.6 18.76 4.6 18V14.24C4.6 13.5 5.2 12.9 5.94 12.9H9.7C10.46 12.9 11.06 13.5 11.06 14.24V18C11.06 18.76 10.46 19.36 9.7 19.36H5.94ZM6.1 17.86H9.56V14.4H6.1V17.86ZM14.44 17.86H17.9V14.4H14.44V17.86Z" />
    </SvgIcon>
  );
});
